import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA_ID || "AW-18128721277";

/**
 * Fires a gtag page_view event on every React Router navigation.
 * Initial load is already tracked by the gtag snippet in index.html.
 */
export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top on every route change so legal/blog pages don't open mid-page.
    window.scrollTo({ top: 0, behavior: "instant" });

    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
      send_to: GA_ID,
    });
  }, [location]);

  return null;
}
